import { createInterfaceId, Injectable } from '@gitlab-org/di';
import { log } from '../log';
import { ErrorTracker } from '../tracking/error_tracker';
import { SanitizedError } from './sanitized_error';

export interface ErrorHandler {
  handleError(message: string, error: unknown): void;
}

export const ErrorHandler = createInterfaceId<ErrorHandler>('ErrorHandler');

@Injectable(ErrorHandler, [ErrorTracker])
export class DefaultErrorHandler implements ErrorHandler {
  #sentryTracker: ErrorTracker;

  constructor(sentryTracker: ErrorTracker) {
    this.#sentryTracker = sentryTracker;
  }

  handleError(messageOrError: Error | string, trailingError?: Error | unknown): void {
    log.error(messageOrError, trailingError);
    const trackedError = trailingError ?? messageOrError;
    if (this.#isTrackableError(trackedError)) {
      this.#sentryTracker.trackError(trackedError);
    }
  }

  #isTrackableError(error: unknown): error is SanitizedError {
    return error instanceof SanitizedError;
  }
}
